import React from "react";
import PropTypes from "prop-types";
import "./UserSubscriptionsList.css";
import { CircularProgress } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const UserSubscriptionsList = (props) => {
  const handleSelect = (val) => {
    props.setSelectedSubscription(val);
    props.onClose(); // Close the modal on item selection
  };

  return (
    <div
      className={`overlaySubs ${props.visible ? "visible" : ""}`}
      onClick={props.onClose} // Close the modal on backdrop click
    >
      <div
        className="modalViewSubs"
        onClick={(e) => e.stopPropagation()} // Prevent modal from closing when clicking inside
      >
        {props.loading ? (
          <CircularProgress color="secondary" />
        ) : (
          <div className="scrollContainerSubs">
            <h2 className="selectRuleTxt">AVAILABLE SUBSCRIPTIONS</h2>
            <div className="optionsContainer">
              {props.data?.map((val, ind) => (
                <div
                  className="optionBtn"
                  key={ind}
                  onClick={() => handleSelect(val)} // Handle item selection
                >
                  <p className="optionTxt">
                    {val.subscriptionType.subscriptionName ===
                    "times allowed(stats)"
                      ? `${val.timesAllowed} uses package`
                      : val.subscriptionType.subscriptionName ===
                        "times allowed(only)"
                      ? `${val.timesAllowed} uses package`
                      : val.subscriptionType.subscriptionName}
                  </p>
                  <p className="optionClockTxt">
                    {val.subscriptionType.type === "clock with stats"
                      ? "Stats Clock"
                      : "Only Clock"}
                  </p>
                  <ChevronRightIcon fontSize="small" />
                </div>
              ))}
              {props.data && props.data.length === 0 && (
                <p className="unavailableTxt">No Subscription available...</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

UserSubscriptionsList.propTypes = {
  data: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  setSelectedSubscription: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UserSubscriptionsList;